
export class ImportData {
    endpoint?: string;
    cast?: string;
    parameters?: any;
    content?: string;
    jsonResponse?: string;
    jsonImport?: string;

    constructor(source?: any) {
        if (source) {
            this.endpoint = source.endpoint;
            this.cast = source.cast;
            this.parameters = source.parameters;
            this.content = source.content;
            this.jsonResponse = source.jsonResponse;
            this.jsonImport = source.jsonImport;
        }
    }
}
